import React from 'react';
import { RiseLoader } from 'react-spinners';

const LoadingOverlay = ({ show }: { show: boolean }) => {
  const loadingColor = '#067dcd';

  console.log('LoadingOverlay Rendered');

  return show ? (
    <div className="position-absolute bg-200 bg-opacity-50 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
      <RiseLoader color={loadingColor} size={10} />
    </div>
  ) : null;
};

export default LoadingOverlay;